export const a11y = {
    ariaLabelPopover: 'Contextual help information',
};
//# sourceMappingURL=strings.js.map